/**
 * Account 도메인 Query Hook Wrapper
 */

import {useQuery} from '@tanstack/react-query';
import {ACCOUNT_QUERY_KEY_MAP} from '../api/account/constant';
import {accountFactory} from '../factory/accountFactory';

// ============================================
// useUserAndCashQuery
// ============================================

/** useUserAndCashQuery variables 타입 */
export interface UserAndCashQueryVariables {
  authInput?: {
    /** OAuth access token */
    accessToken?: string;
    /** Device ID for authentication */
    deviceId?: string;
  };
}

export function useUserAndCashQuery(
  variables?: UserAndCashQueryVariables,
  options?: Parameters<typeof accountFactory.userAndCash>[1]
) {
  const result = useQuery(accountFactory.userAndCash(variables, options));

  // 기존 API 호환성을 위해 loading 별칭 추가
  return {
    ...result,
    loading: result.isLoading,
  };
}

// ReactQueryFetcher 호환을 위한 getKey 메서드
useUserAndCashQuery.getKey = (variables?: UserAndCashQueryVariables) => {
  return [...ACCOUNT_QUERY_KEY_MAP.userAndCash(variables)];
};
